import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "./tasks.css";

export default function Tasks() {
  const [punchDetails, setPunchDetails] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true); // For skeleton loading
  // Fetch employee_id and accessToken from local storage
  const userId = localStorage.getItem("userId");
  const token = localStorage.getItem("accessToken");

  const navigate = useNavigate();

  useEffect(() => {
    // Get today's date in YYYY-MM-DD format
    const todayDate = new Date().toISOString().split("T")[0];
    console.log("date", todayDate);

    // Fetch attendance data
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/attendance/single-attendance/`,
          {
            params: { punch_date: todayDate, employee__id: userId },
            headers: {
              Authorization: `Bearer ${token}`, // Use the token in headers
            },
          }
        );

        const attendanceData = response.data[0];
        if (attendanceData && attendanceData.punch_details) {
          // Set only the first 3 punch details
          setPunchDetails(attendanceData.punch_details.slice(0, 3));
        } else {
          setPunchDetails([]); // No data case
        }
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        setPunchDetails([]); // In case of error, consider no data
      } finally {
        setLoading(false); // Stop loading after data fetch
      }
    };

    fetchData();
  }, []);

  // Handle "View All" button click to navigate to attendance page
  const handleViewAll = () => {
    navigate("/user/myattendence/");
  };

  useEffect(() => {
    const fetchLeaveData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/leavemanagement/leaves/employee/${userId}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLeaveData(response.data);
      } catch (error) {
        console.error("Error fetching leave data:", error);
        setLeaveData([]); // Set empty array on error
      } finally {
        setLoading(false);
      }
    };

    fetchLeaveData();
  }, [userId, token]);

  return (
    <div className="taskConatiner d-flex gap-3">
      {/* MainTasks Table */}
      <div
        className="MainTasks rounded-3 overflow-hidden p-2"
        style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
      >
        <div className="Taskbody">
          <table className="w-100">
            <thead>
              <tr
                className="text-white"
                style={{ backgroundColor: "#cf8f17", height: "35px" }}
              >
                <th>Time</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {/* Show skeleton while loading */}
              {loading ? (
                <>
                  <tr style={{ height: "35px", marginTop: "5px" }}>
                    <td className="skeleton-loader"></td>
                    <td className="skeleton-loader"></td>
                  </tr>
                  <tr style={{ height: "35px", marginTop: "5px" }}>
                    <td className="skeleton-loader"></td>
                    <td className="skeleton-loader"></td>
                  </tr>
                  <tr style={{ height: "35px", marginTop: "5px" }}>
                    <td className="skeleton-loader"></td>
                    <td className="skeleton-loader"></td>
                  </tr>
                </>
              ) : punchDetails.length > 0 ? (
                punchDetails.map((punch, index) => (
                  <tr key={index} style={{ height: "35px" }}>
                    <td>{punch.punch_time}</td>
                    <td>
                      {punch.punch_direction === "clock-in" ? "Check-in" : "Check-out"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr style={{ height: "105px" }}>
                  <td colSpan="2" className="text-center">
                    No punch details today
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div
          className="taskFooter d-flex justify-content-end ps-3 pt-2 pe-2"
          style={{
            height: "30px",
            fontWeight: "500",
            fontSize: "clamp(13px, 1.3vw, 15px)",
          }}
        >
          {/* Conditionally render "View All" button */}
          {punchDetails.length > 0 && !loading && (
            <div
              style={{ cursor: "pointer" }}
              onClick={handleViewAll}
            >
              View All
            </div>
          )}
        </div>
      </div>

      {/* My Leaves Section */}
      <div
        className="MainGraphs rounded-3 overflow-hidden"
        style={{ boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px" }}
      >
        <div className="overviewBody w-100">
          <div className="overviewHeader d-flex w-100 justify-content-between">
            <h6>My Leaves</h6>
            {/* Conditionally render "View All" link */}
            {leaveData.length > 0 && !loading && (
              <Link to={"/user/selfleave"} className="text-decoration-none text-secondary">
                View all
              </Link>
            )}
          </div>

          {/* Show Skeleton Loader While Loading */}
          {loading ? (
            <>
              <div className="leave-item skeleton-loader"></div>
              <div className="leave-item skeleton-loader"></div>
            </>
          ) : leaveData.length > 0 ? (
            leaveData.slice(0, 2).map((leave, index) => (
              <div key={index} className="leave-item d-flex align-items-center py-1 border-bottom">
                <div className="details flex-grow-1">
                  <p className="m-0" style={{ fontSize: "clamp(12px, 1.2vw, 13px)" }}>
                    {`Date : ${leave?.start_date} - Days : ${leave.total_leave_days || 0}`}
                  </p>
                  <div className="d-flex" style={{ fontSize: "clamp(12px, 1.2vw, 13px)" }}>
                    <div className="category">• {leave.leave_type || "General"} - Status : {leave?.status}</div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              className="text-center text-danger py-2 h-100 w-100 d-flex justify-content-center align-items-center"
              style={{ minHeight: "110px" }}
            >
              No leaves!
            </div>
          )}
        </div>
      </div>
    </div>
  );
}